import mitt from 'mitt';
import type { TaskCenterTypes } from '@frontend/api-task-center';

export type TaskEvents = {
  TASK_CREATED: TaskCenterTypes.Task;
  TASK_UPDATED: TaskCenterTypes.UpdateTaskRequest;
  TASK_DELETED: TaskCenterTypes.DeleteTaskRequest;
};

export const taskEvents = mitt<TaskEvents>();
